import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmailsStore,
	TEmailsListRequest,
	TEmailsListResponsePayload,
	TEmailsTypesResponsePayload,
} from './types';

// ==========================================:
export const initialState: TEmailsStore = {
	emailsList: null,
	emailsListLoading: false,
	emailsTypes: [],
	emailsTypesLoading: false,
};

// ==========================================:
const emails = createSlice({
	name: '@@emails',
	initialState,
	reducers: {
		getEmailsListRequest: (state: TEmailsStore, _action: PayloadAction<TEmailsListRequest>) => {
			state.emailsListLoading = true;
		},
		getEmailsListSuccess: (
			state: TEmailsStore,
			action: PayloadAction<TEmailsListResponsePayload>,
		) => {
			state.emailsList = action.payload;
			state.emailsListLoading = false;
		},
		getEmailsListFailure: (state: TEmailsStore) => {
			state.emailsListLoading = false;
		},
		getEmailsTypesRequest: (state: TEmailsStore) => {
			state.emailsTypesLoading = true;
		},
		getEmailsTypesSuccess: (
			state: TEmailsStore,
			action: PayloadAction<TEmailsTypesResponsePayload>,
		) => {
			state.emailsTypes = action.payload;
			state.emailsTypesLoading = false;
		},
		getEmailsTypesFailure: (state: TEmailsStore) => {
			state.emailsTypesLoading = false;
		},
		emailsInitState: () => initialState,
	},
});

export default emails.reducer;
export const {
	getEmailsListRequest,
	getEmailsListSuccess,
	getEmailsListFailure,
	getEmailsTypesRequest,
	getEmailsTypesSuccess,
	getEmailsTypesFailure,
	emailsInitState,
} = emails.actions;
